import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './reducers';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';

import controlledRouteChange from './middleware/controlledRouteChange';
import accessCheck from './middleware/accessCheck';
import sagas from './sagas';

const sagaMiddleware = createSagaMiddleware();

const finalCreateStore = compose(
  // Middleware you want to use in production:
  applyMiddleware(thunk, sagaMiddleware, controlledRouteChange, accessCheck),
  // Other store enhancers if you use any
)(createStore);

export default function configureStore(initialState) {
  const store = finalCreateStore(rootReducer, initialState);
  sagaMiddleware.run(sagas);
  return store;
}



// WEBPACK FOOTER //
// ./src/app/configureStore.prod.js